const my_profile = {
  viewMyClubSeacretProfile: "Mein ClubSeacret-Profil anzeigen", // translated
  verifiedEmail: "Verifizierte E-Mail", // translated
  unverifiedEmail: "unverifizierte Email", // translated
  viewMoreDetails: "Weitere Details anzeigen", // translated
  createdFrom: "Erstellt ab", // translated
  createdTo: "Erstellt bis", // translated
  selectStatus: "Status auswählen...", // translated
  searchByTitle: "Nach Titel suchen...", // translated
};

export default my_profile;
